import { styled, Tooltip } from "@monolith-forensics/monolith-ui";
import { InfoIcon } from "lucide-react";
import { LABELS_HELP_URL } from "../labels.constants";

const StyledHint = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 2px;
  border-radius: 50%;
  cursor: help;
  color: ${({ theme }) => theme.palette.text.secondary};

  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;

const StyledTooltip = styled.div`
  max-width: 260px;
  white-space: normal;

  a {
    margin-left: 4px;
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

/**
 * The (i) on the evidence table's Print Labels menu item: what it does, then
 * Learn more. The hint sits inside the menu item's button, so its clicks stop
 * here and never select the item.
 */
export const PrintLabelsMenuInfo: React.FC = () => (
  <Tooltip
    content={
      <StyledTooltip data-testid="print-labels-menu-info-tooltip">
        Print a label for each selected item on your DYMO printer. You can pick
        the template, set copies and preview the labels first.
        <a
          href={LABELS_HELP_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Learn more about printing labels"
          // The tooltip is portaled outside the menu, so focus moving to the
          // link on mousedown closes the menu, and the tooltip with it, before
          // the click lands.
          onMouseDown={(e) => e.preventDefault()}
          onClick={(e) => e.stopPropagation()}
        >
          Learn more
        </a>
      </StyledTooltip>
    }
    side="right"
    hoverableContent
    delayDuration={0}
  >
    <StyledHint
      role="img"
      aria-label="About Print Labels"
      data-testid="print-labels-menu-info"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <InfoIcon size={12} />
    </StyledHint>
  </Tooltip>
);
